import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { MaterialModule } from 'src/app/material.module';
import { SectionsModule } from 'src/app/platform/nomenclatoare/sections/sections.module';
import { DepartmentsModule } from 'src/app/platform/nomenclatoare/departments/departments.module';
import { StatusModule } from 'src/app/platform/nomenclatoare/status-cerere/status.module';
import { CererePriorityModule } from 'src/app/platform/nomenclatoare/cerere-priority/cerere-priority.module';
import { RequestTypesModule } from 'src/app/platform/nomenclatoare/cerere-type/cerere-type.module';
import { CerereSabloaneModule } from 'src/app/platform/nomenclatoare/cerere-sabloane/cerere-sabloane.module';
import { FunctiiModule } from 'src/app/platform/nomenclatoare/functii/functii.module';
import { JudetModule } from 'src/app/platform/nomenclatoare/judet/judet.module';
import { PermisiuniModule } from 'src/app/platform/nomenclatoare/permisiuni/permisiuni.module';
import { PermisiuniActiuniModule } from 'src/app/platform/nomenclatoare/permisiuni-actiuni/permisiuni-actiuni.module';
import { PlatformAnnouncesModule } from 'src/app/platform/nomenclatoare/platform-announces/platform-announces.module';
import { PlatformFaqModule } from 'src/app/platform/nomenclatoare/platform-faq/platform-faq.module';
import { PlatformSectionModule } from 'src/app/platform/nomenclatoare/platform-section/platform-section.module';
import { PlatformContentModule } from 'src/app/platform/nomenclatoare/platform-content/platform-content.module';
import { NomenclatoareModule } from "../../platform/nomenclatoare/nomenclatoare.module";
import { UatModule } from "../../platform/nomenclatoare/uat/uat.module";
import { OperatoriModule } from 'src/app/platform/nomenclatoare/operatori/operatori.module';
import { DirectieCompartimenteModule } from 'src/app/platform/nomenclatoare/directie-compartimente/directie-compartimente.module';

@NgModule({
    declarations: [SettingsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        DepartmentsModule,
        StatusModule,
        RequestTypesModule,
        CererePriorityModule,
        SectionsModule,
        CerereSabloaneModule,
        FunctiiModule,
        JudetModule,
        PermisiuniModule,
        PermisiuniActiuniModule,
        PlatformContentModule,
        PlatformAnnouncesModule,
        PlatformSectionModule,
        PlatformFaqModule,
        PlatformSectionModule,
        UatModule,
        OperatoriModule,
        DirectieCompartimenteModule,
    ],
    exports: [SettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule { }
